






























































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import { GQL_newInvoiceData_newInvoice } from '@/queries/__generated__/newInvoiceData';
import { IRules } from '@/components/UI/Form/ValidationModule';
import Decimal from '@/utils/decimal';

interface IEditableInvoicePaymentAmounts {
  readonly name: string;
  amount: Decimal;
}

@Component
export default class InvoicePaymentMethodForm extends Vue {
  @Prop() private invoice!: GQL_newInvoiceData_newInvoice;
  @Prop({ type: String, default: 'show' }) private displayType!: 'edit' | 'show';

  @PropSync('valid', { type: Boolean, default: true }) private validFormSync!: boolean;
  private rules: IRules = {
    invoicePaymentMethods: {
      amount: [
        {
          validation: () => {
            if (this.invoice.unit.unitSetting.unitInvoiceSetting.paymentMethods) {
              return this.difference.eq(0);
            } else {
              return true;
            }
          },
          message: i18n => i18n.t('Error.must_sum_to_zero'),
          triggerBy: [ 'invoicePaymentMethods.amount' ],
        },
      ],
    },
  };

  private get paymentMethodsSum(): Decimal {
    return this.invoice.invoicePaymentMethods.reduce((sum, paymentMethod) => sum.add(paymentMethod.amount), new Decimal(0));
  }

  private get difference(): Decimal {
    return this.invoice.orders.reduce((sum, order) => sum.add(order.payableAmount), new Decimal(0)).minus(this.paymentMethodsSum);
  }

  private fillWithDiff(paymentMethod: IEditableInvoicePaymentAmounts): void {
    paymentMethod.amount = paymentMethod.amount.add(this.difference);
  }
}
